import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@app/_core/services/app.service';
import { LoginService } from '@app/_core/services/login.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { UserService } from '@app/_core/services/user.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-invalid-session',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent {
  constructor(
    @Inject(APP_BASE_HREF) public baseHref: string,
    private loginService: LoginService,
    public bsModalRef: BsModalRef,
    private router: Router,
    private userService: UserService,
    private tmQueueService: TmQueueService,
    private appService: AppService,
    private webStorageService: WebStorageService
  ) {}
  errorCode: any;
  Logout() {
    this.userService.logout();
    this.bsModalRef.hide();
  }
  getErrorMessage() {
    return this.loginService.getErrorMessage(this.loginService.errorCode);
  }
}
